export const TABLE = {
  CSV: 1,
  BACKEND: 2,
};

export const columnTitlesPartners = [
  {
    title: 'Mã đối tác',
    dataIndex: 'part_id',
  },
  {
    title: 'Tên đối tác',
    dataIndex: 'part_name',
  },
  {
    title: 'Loại xe',
    dataIndex: 'vhc_type_name',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Thành phố',
    dataIndex: 'city_name',
  },
  {
    title: 'Quận',
    dataIndex: 'district_name',
    hideOn: TABLE.CSV,
  },
  {
    title: 'Hotline',
    dataIndex: 'part_phon',
    hideOn: TABLE.CSV,
  },
  {
    title: 'Liên lạc',
    dataIndex: 'part_ctac_name',
  },
  {
    title: 'Số điện thoại liên lạc',
    dataIndex: 'part_ctac_mobi',
  },
  {
    title: 'Địa chỉ',
    dataIndex: 'part_addr',
  },
  {
    title: 'Email',
    dataIndex: 'part_emai',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
  },
];
